import React from 'react';
import PhoneMockup from '../components/PhoneMockup';
import RevealBlock from '../components/RevealBlock';
import SectionIntro from '../components/SectionIntro';
import { ASSETS } from '../components/assetPaths';
import './AnywhereSection.css';

function AnywhereSection() {
  return (
    <RevealBlock className="ayro-section ayro-section--anytime" aria-labelledby="anytime-heading">
      <SectionIntro kicker="Breathing cues" kickerTone="teal" title="Train anywhere, anytime." headingId="anytime-heading">
        Start a session with <strong>sound</strong> to use while you're cooking, journaling, or stretching. Use <strong>haptics</strong> while commuting or watching TV. Switch to <strong>picture-in-picture</strong> mode when using your phone.
      </SectionIntro>
      <div className="ayro-anytimeMedia" aria-label="Ayro picture in picture breathwork preview">
        <PhoneMockup className="ayro-phonePreview" type="video" src={ASSETS.pipVideo} alt="Ayro breathwork while using your phone" />
        <div className="ayro-floatingCue ayro-floatingCue--sound">Sound</div>
        <div className="ayro-floatingCue ayro-floatingCue--haptics">Haptics</div>
        <div className="ayro-pipCard">
          <span>Picture in Picture</span>
        </div>
      </div>
    </RevealBlock>
  );
}

export default AnywhereSection;
